import { render, staticRenderFns } from "./CodDeposits.vue?vue&type=template&id=06fbc8c0&"
import script from "./CodDeposits.vue?vue&type=script&lang=js&"
export * from "./CodDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports